import { IReportInvoiceByDateResponce, IReportServiceByDateResponce } from '@/domain/IReport'
import animateToggle from '@/scripts/animatetoggle'
import dropDown from '@/scripts/dropdown'
import * as XLSX from 'xlsx'
import store from '@/store'
import Axios from 'axios'
import { Vue } from 'vue-property-decorator'
import { nextTick } from 'vue'
import i18n from '@/i18n'

export default {
    methods: {
        // Formatting
        formatDate (date: string): string {
            if (date === undefined) return ''
            const parts = date.split('-')
            if (parts.length === 3) {
                const [year, month, day] = parts
                return `${day}.${month}.${year}`
            }
            return date
        },

        formatNumber (num: number): string {
            const parts = num.toFixed(2).split('.')
            const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
            const decimalPart = parts[1]
            return integerPart + ',' + decimalPart
        },

        formatSum (sum: number): string {
            return this.formatNumber(sum) + ' €'
        },

        totalSum (data: IReportServiceByDateResponce): number { // For servicebydate response
            if (data) {
                return data.services.reduce((total, item) => total + item.ttlsellrate, 0)
            }
            return 0
        },

        // For dropdown calendar
        handleDateChange () { // For servicebydate response
            const selectedDates = this.selectedDateRange
            if (selectedDates.split(' to ').length === 2) {
                this.generateReportOk = true
                this.ServiceByDateRequest.service.servicestartdate = selectedDates.split(' to ')[0]
                this.ServiceByDateRequest.service.serviceenddate = selectedDates.split(' to ')[1]
                // Format dates for the request
                this.ServiceByDateRequest.service.servicestartdate = this.ServiceByDateRequest.service.servicestartdate.replace(/\./g, '-')
                this.ServiceByDateRequest.service.serviceenddate = this.ServiceByDateRequest.service.serviceenddate.replace(/\./g, '-')

                const startParts = this.ServiceByDateRequest.service.servicestartdate.split('-')
                this.ServiceByDateRequest.service.servicestartdate = `${startParts[2]}-${startParts[1]}-${startParts[0]}`

                const endParts = this.ServiceByDateRequest.service.serviceenddate.split('-')
                this.ServiceByDateRequest.service.serviceenddate = `${endParts[2]}-${endParts[1]}-${endParts[0]}`

                this.selectedDateRange = this.selectedDateRange.replace('to', '—')
            }
        },
        quickSelectDates (range
            :
            string
        ) { // For servicebydate response
            const currentDate = new Date()
            const currentYear = currentDate.getFullYear()
            const currentMonth = currentDate.getMonth() + 1
            let startDate: Date
            let endDate: Date
            switch (range) {
            case 'currentMonth':
                startDate = new Date(currentYear, currentMonth - 1, 1) // Start of the current month.
                endDate = new Date(currentYear, currentMonth, 0) // End of the current month.;
                break
            case 'lastMonth':
                if (currentMonth === 1) {
                    startDate = new Date(currentYear - 1, 11, 1) // Start of December in the previous year.
                    endDate = new Date(currentYear - 1, 12, 0) // End of December in the previous year.
                } else {
                    startDate = new Date(currentYear, currentMonth - 2, 1) // Start of the previous month.
                    endDate = new Date(currentYear, currentMonth - 1, 0) // End of the previous month.
                }
                break
            case 'currentYear':
                startDate = new Date(currentYear, 0, 1) // Start of the current year.
                endDate = new Date(currentYear, 12, 0) // End of the current year.
                break
            case 'lastYear':
                startDate = new Date(currentYear - 1, 0, 1) // Start of the current year.
                endDate = new Date(currentYear - 1, 12, 0) // End of the current year.
            }
            // Format the start and end dates as strings and set the selectedDateRange.
            const startDateStr = startDate.toLocaleDateString('en-GB', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            }).replaceAll('/', '.')
            const endDateStr = endDate.toLocaleDateString('en-GB', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            }).replaceAll('/', '.')

            this.selectedDateRange = `${startDateStr} to ${endDateStr}`
            this.handleDateChange()
        },
        // animations
        dropdown (trigger) {
            dropDown(this.$refs[trigger])
        },

        animatetoggle (trigger) {
            animateToggle(this.$refs[trigger])
        },

        // Downloading
        download (DownloadFileType
            :
            string, reportType : string, summary?
        ) {
            const services = store.getters.getServiceByDateResponce.services
            let mappedServices = [];
            if (reportType === 'detailed-service') {
                mappedServices = services.map(service => ({
                    [i18n.t('reports.table.invoice_no').toString()]: service.documents.find(document => document.documentType === 'INVOICE') === undefined ? null : service.documents.find(document => document.documentType === 'INVOICE').documentNo,
                    [i18n.t('reports.table.service_start_date').toString()]: this.formatDate(service.servicestartdate),
                    [i18n.t('reports.table.service_end_date').toString()]: this.formatDate(service.serviceenddate),
                    [i18n.t('reports.table.all_departures').toString()]: service.servicedeparturecountry,
                    [i18n.t('reports.table.all_destinations').toString()]: service.servicedestinationcountry,
                    [i18n.t('reports.table.passenger_name').toString()]: service.servicepassengerlist.map(passenger => passenger.name).join(', '),
                    [i18n.t('reports.table.all_services').toString()]: service.productname,
                    [i18n.t('reports.table.qty').toString()]: service.qty,
                    [i18n.t('reports.table.invoice_sum').toString()]: service.ttlsellrate,
                    [i18n.t('reports.table.all_service_providers').toString()]: service.serviceprovider,
                    [i18n.t('reports.table.consultant').toString()]: service.travelconsultant,
                    [i18n.t('reports.table.booked_by').toString()]: service.bookedbyname,
                    [i18n.t('reports.table.sales_channel').toString()]: service.saleschannels
                }))
            } else if (reportType === 'summary-service') {
                mappedServices = Array.from(summary.entries()).map(entry => ({
                    [i18n.t('reports.table.service_groups').toString()]: entry[0],
                    [i18n.t('reports.table.invoice_sum').toString()]: entry[1]
                }))
            } else if (reportType === 'detailed-passenger') {
                mappedServices = services.map(service => ({
                    [i18n.t('reports.table.passenger_name').toString()]: service.servicepassengerlist.map(passenger => passenger.name).join(', '),
                    [i18n.t('reports.table.passenger_ref_no').toString()]: service.servicepassengerlist.map(passenger => passenger.reference).filter(Boolean).join(', '),
                    [i18n.t('reports.table.invoice_no').toString()]: service.documents.find(document => document.documentType === 'INVOICE') === undefined ? null : service.documents.find(document => document.documentType === 'INVOICE').documentNo,
                    [i18n.t('reports.table.invoice_sum').toString()]: service.ttlsellrate,
                    [i18n.t('reports.table.booked_by').toString()]: service.bookedbyname
                }))
            } else if (reportType === 'summary-passenger') {
                mappedServices = Array.from(summary.entries()).map(entry => ({
                    [i18n.t('reports.table.passenger_name').toString()]: entry[0],
                    [i18n.t('reports.table.invoice_sum').toString()]: entry[1]
                }))
            } else if (reportType === 'travel') {
                mappedServices = services.map(service => ({
                    [i18n.t('reports.table.service_start_date').toString()]: this.formatDate(service.servicestartdate),
                    [i18n.t('reports.table.service_end_date').toString()]: this.formatDate(service.serviceenddate),
                    [i18n.t('reports.table.passenger_name').toString()]: service.servicepassengerlist.map(passenger => passenger.name).join(', '),
                    [i18n.t('reports.table.all_destinations').toString()]: service.servicedestinationcountry,
                    [i18n.t('reports.table.all_services').toString()]: service.productname,
                    [i18n.t('reports.table.documents').toString()]: service.documents.map(doc => doc.documentNo).filter(Boolean).join(', ')
                }))
            }
            const data = XLSX.utils.json_to_sheet(mappedServices)
            const wb = XLSX.utils.book_new()
            XLSX.utils.book_append_sheet(wb, data, 'data')
            if (DownloadFileType === '.xlsx') {
                XLSX.writeFile(wb, reportType + '-report.xlsx')
            } else if (DownloadFileType === '.csv') {
                XLSX.writeFile(wb, reportType + '-report.csv', { bookType: 'csv' })
            }
        },
        downloadInvoice (documentId
            :
            string, label
            :
            string
        ) {
            const url = '/api/invoices/' + documentId + "?customerid=" + store.state.customerId
            const encodedToken = store.state.token
            Axios.get(url, {
                headers: { "Authentication-Estravel": 'Bearer ' + encodedToken },
                responseType: 'blob'
            }).then(response => {
                const blob = new Blob([response.data], { type: 'application/pdf' })
                const link = document.createElement('a')
                link.href = URL.createObjectURL(blob)
                link.download = label
                link.click()
                URL.revokeObjectURL(link.href)
            }).catch(console.error)
        },
        downloadDocument (documentId
            :
            string, documentType
            :
            string, label
            :
            string
        ) {
            let type = ''
            switch (documentType) {
            case 'ITINERARY':
                type = 'itineraries'
                break
            case 'VOUCHER':
                type = 'vouchers'
                break
            case 'FILE':
                type = 'files'
                break
            case 'AIR_TICKET':
                type = 'tickets'
                break
            case 'INVOICE':
                type = 'invoices'
                break
            default:
                type = 'files'
            }
            let url = ''
            if (type === 'invoices') {
                url = '/api/invoices/' + documentId
            } else {
                url = '/api/documents/' + type + '/' + documentId
            }
            url += "?customerid=" + store.state.customerId
            const encodedToken = store.state.token
            Axios.get(url, {
                headers: { "Authentication-Estravel": 'Bearer ' + encodedToken },
                responseType: 'blob'
            }).then(response => {
                const blob = new Blob([response.data], { type: 'application/pdf' })
                const link = document.createElement('a')
                link.href = URL.createObjectURL(blob)
                link.download = label
                link.click()
                URL.revokeObjectURL(link.href)
            }).catch(console.error)
        },

        // Scrolling functions

        scrollToResultsTable () : void {
            const resultsTableElement = document.getElementById('resultsTable');
            const scrollOptions: any = {
                behavior: 'smooth',
                block: 'start'
            };
            scrollOptions.top = Math.max(resultsTableElement.getBoundingClientRect().top + window.scrollY - 60, 0);
            window.scrollTo(scrollOptions);
        },

        scrollToAlertMessage () : void {
            const errorMessageElement = document.getElementsByClassName('title-2xl')[0];
            // errorMessageElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
            const scrollOptions: any = {
                behavior: 'smooth',
                block: 'start'
            };
            // Ensure the top offset is not negative to avoid scrolling too far up
            // Calculate the adjusted top offset by subtracting navbar height
            scrollOptions.top = Math.max(errorMessageElement.getBoundingClientRect().top + window.scrollY - 100, 0);
            // Scroll to the adjusted position
            window.scrollTo(scrollOptions);
        },

        // Report's description expansion
        initDescriptionExpansion () : void {
            Vue.nextTick(() => {
                const descContainer = this.$refs.descContainer as HTMLElement
                const showFullDescLink = descContainer.querySelector('a'); // Assuming the link is within the descContainer
                showFullDescLink.style.cursor = 'pointer';
                if (this.showFullDesc === true) {
                    showFullDescLink.style.display = 'none';
                }
                if (showFullDescLink instanceof HTMLElement) {
                    showFullDescLink.addEventListener('click', (event) => {
                        event.preventDefault();
                        this.showFullDesc = true
                        showFullDescLink.style.display = 'none';
                    });
                    showFullDescLink.addEventListener('mouseenter', () => {
                        showFullDescLink.style.color = 'orange'; // Change color on hover
                    });
                    showFullDescLink.addEventListener('mouseleave', () => {
                        showFullDescLink.style.color = 'inherit'; // Change color back on mouse leave
                    });
                }
            })
        }
    }
}
